
export default {
  name: "elasticBreadcrumbs",
};
